import { gql } from 'graphql-tag'

const WEEKLY_OPENING_HOURS_FRAGMENT = gql`
  fragment WeeklyOpeningHours on WeekdayOpeningHours {
    MON {
      opens
      closes
      schedules {
        opens
        closes
      }
    }
    TUE {
      opens
      closes
      schedules {
        opens
        closes
      }
    }
    WED {
      opens
      closes
      schedules {
        opens
        closes
      }
    }
    THU {
      opens
      closes
      schedules {
        opens
        closes
      }
    }
    FRI {
      opens
      closes
      schedules {
        opens
        closes
      }
    }
    SAT {
      opens
      closes
      schedules {
        opens
        closes
      }
    }
    SUN {
      opens
      closes
      schedules {
        opens
        closes
      }
    }
  }
`

export const expressCheckoutPageQuery = gql`
  query ExpressCheckoutPageQuery($stationId: ID!) {
    expressCheckoutMenu(stationId: $stationId) {
      categories {
        id
        name
        defaultOpeningHours {
          ...WeeklyOpeningHours
        }
      }
    }
    expressCheckoutSchedules(stationId: $stationId) {
      id
      siteId
      name
      startDate
      endDate
      categories {
        id
        name
        opens
        closes
        schedules {
          opens
          closes
        }
      }
    }
    expressCheckoutCategoryPeriods(stationId: $stationId) {
      periodId
      categoryId
      periodName
      startDate
      endDate
      openingHours {
        ...WeeklyOpeningHours
      }
    }
  }
  ${WEEKLY_OPENING_HOURS_FRAGMENT}
`

export const fetchExpressCheckoutMenuByStationId = gql`
  query ExpressCheckoutQuery($stationId: ID!) {
    expressCheckoutMenu(stationId: $stationId) {
      categories {
        id
        name
        defaultOpeningHours {
          ...WeeklyOpeningHours
        }
      }
    }
    expressCheckoutSchedules(stationId: $stationId) {
      id
      siteId
      name
      startDate
      endDate
    }
  }
  ${WEEKLY_OPENING_HOURS_FRAGMENT}
`

export const fetchExpressCheckoutNewExceptionalScheduleWithBasis = gql`
  query ExpressCheckoutNewExceptionalScheduleWithBasis($stationId: ID!, $fromScheduleId: ID!) {
    expressCheckoutMenu(stationId: $stationId) {
      categories {
        id
        name
        defaultOpeningHours {
          ...WeeklyOpeningHours
        }
      }
    }
    expressCheckoutSchedule(id: $fromScheduleId, stationId: $stationId) {
      id
      siteId
      name
      startDate
      endDate
      categories {
        id
        name
        opens
        closes
      }
    }
    expressCheckoutSchedules(stationId: $stationId) {
      id
      siteId
      name
      startDate
      endDate
    }
  }
  ${WEEKLY_OPENING_HOURS_FRAGMENT}
`

export const upsertExpressCheckoutExceptionalSchedule = gql`
  mutation UpsertExpressCheckoutExceptionalSchedule(
    $id: ID
    $stationId: ID!
    $name: String!
    $startDate: String!
    $endDate: String!
    $categories: [ScheduleCategoryInput!]!
  ) {
    upsertExpressCheckoutExceptionalSchedule(
      id: $id
      stationId: $stationId
      name: $name
      startDate: $startDate
      endDate: $endDate
      categories: $categories
    ) {
      id
    }
  }
`
export const fetchExpressCheckoutSchedulesByStationId = gql`
  query ExpressCheckoutSchedules($stationId: ID!) {
    expressCheckoutSchedules(stationId: $stationId) {
      id
      siteId
      name
      startDate
      endDate
      categories {
        id
        name
        opens
        closes
        schedules {
          opens
          closes
        }
      }
    }
  }
`

export const fetchExpressCheckoutScheduleById = gql`
  query ExpressCheckoutSchedule($id: ID!, $stationId: ID!) {
    expressCheckoutSchedule(id: $id, stationId: $stationId) {
      id
      siteId
      name
      startDate
      endDate
      categories {
        id
        name
        opens
        closes
        schedules {
          opens
          closes
        }
      }
    }
    expressCheckoutMenu(stationId: $stationId) {
      categories {
        id
        name
        defaultOpeningHours {
          ...WeeklyOpeningHours
        }
      }
    }
    expressCheckoutSchedules(stationId: $stationId) {
      id
      siteId
      name
      startDate
      endDate
    }
  }
  ${WEEKLY_OPENING_HOURS_FRAGMENT}
`

export const fetchExpressCheckoutPeriodPage = gql`
  query ExpressCheckoutPeriodPage($stationId: ID!) {
    expressCheckoutMenu(stationId: $stationId) {
      categories {
        id
        name
        defaultOpeningHours {
          ...WeeklyOpeningHours
        }
      }
    }
    expressCheckoutCategoryPeriods(stationId: $stationId) {
      periodId
      categoryId
      periodName
      startDate
      endDate
      openingHours {
        ...WeeklyOpeningHours
      }
    }
  }
  ${WEEKLY_OPENING_HOURS_FRAGMENT}
`

export const fetchExpressCheckoutNewPeriodPage = gql`
  query ExpressCheckoutNewPeriodPage($stationId: ID!) {
    expressCheckoutMenu(stationId: $stationId) {
      categories {
        id
        name
        defaultOpeningHours {
          ...WeeklyOpeningHours
        }
      }
    }
    expressCheckoutCategoryPeriods(stationId: $stationId) {
      periodId
      categoryId
      periodName
      startDate
      endDate
    }
  }
  ${WEEKLY_OPENING_HOURS_FRAGMENT}
`

export const fetchExpressCheckoutEditPeriodPage = gql`
  query ExpressCheckoutEditPeriodPage($stationId: ID!, $periodId: ID!) {
    expressCheckoutMenu(stationId: $stationId) {
      categories {
        id
        name
        defaultOpeningHours {
          ...WeeklyOpeningHours
        }
      }
    }
    expressCheckoutCategoryPeriod(stationId: $stationId, periodId: $periodId) {
      periodId
      categoryId
      periodName
      startDate
      endDate
      openingHours {
        ...WeeklyOpeningHours
      }
    }
    expressCheckoutCategoryPeriods(stationId: $stationId) {
      periodId
      categoryId
      periodName
      startDate
      endDate
    }
  }
  ${WEEKLY_OPENING_HOURS_FRAGMENT}
`

export const upsertExpressCheckoutPeriodSchedule = gql`
  mutation UpsertExpressCheckoutPeriodSchedule($stationId: ID!, $period: PeriodScheduleCategoryInput!) {
    upsertExpressCheckoutPeriodSchedule(stationId: $stationId, period: $period) {
      categoryId
    }
  }
`

export const removeExpressCheckoutCategoryPeriod = gql`
  mutation RemoveExpressCheckoutCategoryPeriod($stationId: ID!, $periodId: ID!) {
    removeExpressCheckoutPeriodSchedule(stationId: $stationId, periodId: $periodId)
  }
`

export const removeExpressCheckoutSchedule = gql`
  mutation RemoveExpressCheckoutSchedule($id: ID!, $stationId: ID!) {
    removeExpressCheckoutExceptionalSchedule(id: $id, stationId: $stationId)
  }
`

export const fetchExpressCheckoutProductAvailabilities = gql`
  query ExpressCheckoutProductAvailabilities($stationId: ID!) {
    expressCheckoutProductAvailabilities(stationId: $stationId) {
      name
      products {
        productId
        name
        ean
        available
        status
        modifiers {
          productId
          name
          type
          available
        }
      }
      categories {
        name
        products {
          productId
          name
          ean
          available
          status
          modifiers {
            productId
            name
            type
            available
          }
        }
      }
    }
  }
`

export const upsertExpressCheckoutProductAvailabilities = gql`
  mutation UpsertExpressCheckoutProductAvailabilities(
    $stationId: ID!
    $unavailableProducts: [UnavailableProductInput!]!
  ) {
    upsertExpressCheckoutProductAvailabilities(stationId: $stationId, unavailableProducts: $unavailableProducts) {
      siteId
    }
  }
`

export const fetchRestaurantMenuCategory = gql`
  query RestaurantMenuCategory($stationId: ID!, $categoryId: String!) {
    restaurantMenuCategory(stationId: $stationId, categoryId: $categoryId) {
      id
      name
      products {
        id
        assortment
        targets
        name
      }
    }
  }
`
